module.exports = __webpack_public_path__ + "img/giftcard-background-desktop.c9a5564.png";